import { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross2 } from "react-icons/rx";
import { AiOutlinePlus, AiOutlineDelete } from "react-icons/ai";
import CommonButton from "../../common/CommonButton";
import ReactSelector from "../../common/CommonReactSelector";
import { components } from 'react-select';
import {
  fetchFieldAgent,
  getAllAgentList,
  getAllGeoCode,
  getAllOutstandingRange,
  getAllSpecialAssign,
  getAllTypeCode,
  getSpecialAssign
} from "../../../service/Configuration";
import AppContext from "../../../context/AppContext";
import { toast } from "react-toastify";

const Placeholder = (props) => <components.Placeholder {...props} />;

export default function NewRuleModal({ newRule, setNewRule, setSpecialAssign }) {
  const { activityId } = useContext(AppContext);
  const organizationId = JSON.parse(localStorage.getItem("selectedOrgId"));

  const [rules, setRules] = useState([{
    assigneeIds: [],
    areaCodes: [],
    typeCodes: [],
    outstandingRange: [],
    active: true
  }]);

  const [agentList, setAgentList] = useState([]);
  const [GeoCodes, setGeoCodes] = useState([]);
  const [typeCodes, setTypeCodes] = useState([]);
  const [outstandingRange, setOutstandingRange] = useState([]);
  const [assign, setAssign] = useState(false);

  useEffect(() => {
    getAllOutstandingRange().then(setOutstandingRange).catch(console.error);
    getAllTypeCode(activityId).then(setTypeCodes).catch(console.error);
    getAllGeoCode(activityId).then(setGeoCodes).catch(console.error);
    fetchFieldAgent(activityId).then(setAgentList).catch(console.error);

  }, [activityId]);

  const handleChange = (index, field, values) => {
    const updatedRules = [...rules];
    updatedRules[index][field] = values?.map(item => item.value) || [];
    setRules(updatedRules);
  };

  const handleAddRule = () => {
    setRules([
      ...rules,
      { assigneeIds: [], areaCodes: [], typeCodes: [], outstandingRange: [], active: true }
    ]);
  };

  const handleRemoveRule = (index) => {
    const updatedRules = [...rules];
    updatedRules.splice(index, 1);
    setRules(updatedRules);
  };

  const handleSubmit = async () => {
    const payload = {
      workflowId: activityId,
      ruleList: rules,
      assign: assign
    };

    const result = await getSpecialAssign({ payload });
    if (result.header.code === 600) {
      toast.success(result.body.value); // Show toast
    }
    else if (result.header.code === 601) {
      toast.success(result.body.value); // Show toast

    } else {
      toast.error("Failed to assign all rule"); // Show toast
    }
    if (result.header.code === 600) {
      const data = await getAllSpecialAssign(activityId, 0, 10);
      setSpecialAssign(data?.ruleList);
    }
    setNewRule(false);
  };

  return (
    <Transition appear show={newRule} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setNewRule}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-5xl rounded-lg bg-white shadow-xl transform transition-all p-6 flex flex-col gap-[27px] max-h-[90vh] overflow-y-auto">
              <Dialog.Title className="text-base font-bold text-[#000000] text-left flex justify-between">
                New Rule
                <button
                  type="button"
                  className="text-gray-600 transition-transform transform hover:scale-110 w-[20px] h-[20px]"
                  onClick={() => setNewRule(false)}
                >
                  <RxCross2 className="h-6 w-6" />
                </button>
              </Dialog.Title>
              <div className="flex items-center gap-3">
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Assign All
                </label>
                <button
                  onClick={() => setAssign(prev => !prev)}
                  className={`px-4 py-1 rounded-full text-sm font-medium border transition duration-300
      ${assign ? "bg-green-500 text-white border-green-500" : "bg-gray-200 text-gray-800 border-gray-300"}`}
                >
                  {assign ? "Assigned All" : "Not Assigned All"}
                </button>
              </div>

              {rules.map((rule, index) => (
                <div
                  key={index}
                  className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 border border-gray-200 rounded-md p-8 mb-4"
                >
                  {rules.length > 1 && (
                    <button
                      className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                      onClick={() => handleRemoveRule(index)}
                    >
                      <AiOutlineDelete className="w-5 h-5" />
                    </button>
                  )}

                  <div className="w-full">
                    <ReactSelector
                      options={agentList?.map(({ userId, name }) => ({
                        value: userId,
                        label: name
                      }))}
                      onChange={(selected) => handleChange(index, "assigneeIds", selected)}
                      components={{ Placeholder }}
                      placeholder="Agent Name"
                      isMulti
                      isClearable={false}
                      background="#EBF5FF"
                      optionbackground="#EBF5FF"
                       overflow="overlay"
                    />
                  </div>

                  <div className="w-full">
                    <ReactSelector
                      options={GeoCodes?.filter(Boolean)?.map(code => ({ value: code, label: code }))}
                      onChange={(selected) => handleChange(index, "areaCodes", selected)}
                      components={{ Placeholder }}
                      placeholder="Select Geo Code"
                      isMulti
                      isClearable={false}
                      background="#EBF5FF"
                      optionbackground="#EBF5FF"
                      overflow="overlay"
                    />
                  </div>

                  <div className="w-full">
                    <ReactSelector
                      options={typeCodes?.filter(Boolean)?.map(code => ({ value: code, label: code }))}
                      onChange={(selected) => handleChange(index, "typeCodes", selected)}
                      components={{ Placeholder }}
                      placeholder="Select Type Code"
                      isMulti
                      isClearable={false}
                      background="#EBF5FF"
                      optionbackground="#EBF5FF"
                       overflow="overlay"
                    />
                  </div>

                  <div className="w-full">
                    <ReactSelector
                      options={outstandingRange?.map(range => ({ value: range, label: range }))}
                      onChange={(selected) => handleChange(index, "outstandingRange", selected)}
                      components={{ Placeholder }}
                      placeholder="Select Amount Range"
                      isMulti
                      isClearable={false}
                      background="#EBF5FF"
                      optionbackground="#EBF5FF"
                       overflow="overlay"
                    />
                  </div>

                  <div className="flex gap-2 justify-start items-center">
                    <label
                      htmlFor={`toggle-switch-${index}`}
                      className="text-sm font-semibold text-gray-900"
                    >
                      Status
                    </label>
                    <div className="relative">
                      <input
                        type="checkbox"
                        id={`toggle-switch-${index}`}
                        checked={rule.active}
                        onChange={() => {
                          const updatedRules = [...rules];
                          updatedRules[index].active = !rule.active;
                          setRules(updatedRules);
                        }}
                        className="sr-only"
                      />
                      <label
                        htmlFor={`toggle-switch-${index}`}
                        className={`block w-14 h-7 rounded-full cursor-pointer transition-colors duration-300 ${rule.active ? "bg-green-500" : "bg-gray-300"
                          }`}
                      >
                        <span
                          className={`absolute left-1 top-1 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${rule.active ? "translate-x-7" : ""
                            }`}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              ))}


              <div className="flex justify-start">
                <button
                  onClick={handleAddRule}
                  className="flex items-center gap-2 text-sm text-blue-600 hover:underline"
                >
                  <AiOutlinePlus className="text-lg" /> Add Rule
                </button>
              </div>

              <div className="flex justify-center gap-[4px]">
                <CommonButton
                  onClick={handleSubmit}
                  className="w-20 !px-[10px] !block rounded-sm"
                  variant="primary"
                >
                  Ok
                </CommonButton>

                <button
                  onClick={() => setNewRule(false)}
                  className="w-20 rounded-sm border border-[#236DB4] text-[#236DB4] text-xs font-bold"
                >
                  Cancel
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
